import { render, staticRenderFns } from "./bigButton.vue?vue&type=template&id=757161b0&scoped=true&lang=pug"
import script from "./bigButton.vue?vue&type=script&lang=ts"
export * from "./bigButton.vue?vue&type=script&lang=ts"
import style0 from "./bigButton.vue?vue&type=style&index=0&id=757161b0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757161b0",
  null
  
)

export default component.exports